<script lang="ts">
  import { addSheet, placementMode, type PlacementMode } from '../lib/state';

  const btns = [
    { kind: 'friend', icon: '🙂', label: 'Add friend' },
    { kind: 'trip', icon: '📍', label: 'Add place' },
    { kind: 'candidate', icon: '🏠', label: 'Add home' },
  ] as const;

  function open(kind: Exclude<PlacementMode, 'none'>) {
    // A half-finished pin placement shouldn't survive into the add form.
    placementMode.set('none');
    addSheet.set(kind);
  }
</script>

<div class="mobile-cta" role="toolbar" aria-label="Quick add">
  {#each btns as b}
    <button
      class="mobile-cta-btn"
      class:active={$placementMode === b.kind || $addSheet === b.kind}
      aria-pressed={$placementMode === b.kind || $addSheet === b.kind}
      aria-label={b.label}
      on:click={() => open(b.kind)}
    >
      <span class="mobile-cta-icon" aria-hidden="true">{b.icon}</span>
      <span>{b.label}</span>
    </button>
  {/each}
</div>
